import { ReactComponent as TgIcon } from 'assets/images/socialNetworks/telegram-icon.svg';
import { ReactComponent as WaIcon } from 'assets/images/socialNetworks/whats-app-icon.svg';
import { ImageComponent } from 'components/Image';
import { LanguageSwitcher } from 'components/LanguageSwitcher';
import { LocalizedLink } from 'components/LocalizedLink';
import { ScContainer } from 'components/styles/common';
import { useFooterMenuList } from 'hooks/footerMenuList';
import SeoContent from 'modules/seo/content/SeoContent';
import { useTranslation } from 'react-i18next';
import { Copyright } from './components/Copyright';
import { DownloadButtons } from './components/DownloadButtons';
import { Licenses } from './components/Licenses';
import { awardsImages } from './helper';
import { ScAddons, ScAwards, ScFooter, ScNav } from './styled';

export const TELEGRAM_URL = 'https://t.me/luckyelf';
export const WHATSAPP_URL =
  'https://whatsapp.com/channel/0029VaAmwZA17EmygmFiP13w';

export const Footer = () => (
  <ScFooter>
    <SeoContent />
    <ScContainer>
      <Awards />
      <Nav />
      <div className="footer-bottom-box">
        <Copyright />
        <div className="footer-bottom">
          <Licenses />
          <Addons />
        </div>
      </div>
    </ScContainer>
  </ScFooter>
);

const Nav = () => {
  const { t } = useTranslation();

  const footerMenuList = useFooterMenuList();

  return (
    <ScNav>
      <ul>
        {footerMenuList.map(
          ({ name, url, onClick, isHidden }, index) =>
            !isHidden && (
              <li key={index}>
                <LocalizedLink href={url} onClick={onClick}>
                  {name}
                </LocalizedLink>
              </li>
            )
        )}
        <li>
          <button id="intercomcustomLauncher" type="button">
            {t('glossary:helpdesk')}
          </button>
        </li>
      </ul>
    </ScNav>
  );
};

const Addons = () => {
  const { t } = useTranslation('common');

  return (
    <ScAddons>
      <div className="col">
        <LanguageSwitcher />
      </div>
      <DownloadButtons />
      <div className="col">
        <div className="social-network-box">
          <span>{t('socialNetworks.followUs')}</span>
          <LocalizedLink href={TELEGRAM_URL} target={'_blank'}>
            <TgIcon />
          </LocalizedLink>
          <LocalizedLink href={WHATSAPP_URL} target={'_blank'}>
            <WaIcon />
          </LocalizedLink>
        </div>
      </div>
    </ScAddons>
  );
};

const Awards = () => (
  <ScAwards>
    {awardsImages.map(({ src, alt }, index) => (
      <ImageComponent alt={alt} height={44} key={index} src={src} width={202} />
    ))}
  </ScAwards>
);
